import { FC } from 'react'
import { AnchorButton, FlexContainer, MainContainer, Text3XL, TextXL } from '@reapit/elements'
import { cssMainErrorPage404Container } from './styles'

export const NotFoundPage: FC = () => {
  return (
    <MainContainer>
      <FlexContainer isFlexGrow1 isFlexAlignCenter isFlexJustifyCenter className={cssMainErrorPage404Container}>
        <Text3XL intent="secondary" className="el-pb4">
          Page Not Found
        </Text3XL>
        <TextXL intent="secondary" className="el-pb8">
          The page you are looking for does not exist.
        </TextXL>
        <AnchorButton size="medium" variant="primary" className="el-w-auto" href="/">
          Return to home page
        </AnchorButton>
      </FlexContainer>
    </MainContainer>
  )
}
